<template>
  <div
    class="playbook-page-column-item"
    :class="
      'playbook-page-column-item-' +
      playbookPageLayoutSize +
      (hasMoreThanTwoItems ? ' full-content' : '') +
      ' item-index-' +
      itemIndex +
      (isLastItem ? ' last-item' : '')
    "
  >
    <component
      v-if="product"
      :is="componentName"
      :product="product"
      :originalProduct="product"
      :content="product.content"
      :withDescription="withDescription"
      :pageType="pageType"
      :itemsCount="itemsCount"
      :readOnly="readOnly"
      :withProductGrid="withProductGrid"
      :withImage="withImage"
      :layout="product ? product.layout : null"
      :pageId="pageId"
      :columnIndex="columnIndex"
      :itemIndex="itemIndex"
      :precoloredDesign="
        product.precolored ? product.precolored : product.precolored_path
      "
      :precoloredDesignShadow="precoloredDesignShadow"
      :designDimension="designDimension ? designDimension : designDimensionASD"
      :singleLayer="product.single_layer"
      :layoutOverride="layoutOverride || product.layout"
      :sportName="sportName"
      :layoutIndex="layoutIndex"
      :precoloredType="product.precolored_type"
      :anonymousCrossOrigin="anonymousCrossOrigin"
      :isChromagear="isChromagear"
      :isFeatured="!!product.featured"
      :featuredDesignName="product.featured"
      :featuredInfoType="featuredInfoType"
      :hasFeaturedInfo="hasFeaturedInfo"
      :nameOverride="product.label"
      :productIsEditable="productIsEditable"
      :heroDesign="product.design"
    />
  </div>
</template>

<script>
import Product from "@/components/Projects/Product/Product.vue";
import HTMLDisplay from "@/components/Projects/Playbooks/HTMLDisplay.vue";
import ProductInfo from "@/components/Projects/Product/ProductInfo.vue";
import HeroDisplay from "@/components/Projects/Playbooks/HeroDisplay.vue";

export default {
  name: "PageColumnItem",
  props: {
    product: {
      type: Object,
      required: true,
    },
    itemsCount: {
      type: Number,
      required: true,
    },
    pageType: {
      type: String,
    },
    readOnly: {
      type: Boolean,
    },
    pageId: {
      type: Number,
    },
    columnIndex: {
      type: Number,
    },
    itemIndex: {
      type: Number,
    },
    designDimension: {
      type: Object,
    },
    precoloredDesignShadow: {
      type: String,
    },
    sportName: {
      type: String,
    },
    layoutIndex: {
      type: Number,
    },
    layoutOverride: {
      type: Object,
    },
    anonymousCrossOrigin: {
      type: Boolean,
    },
    isChromagear: {
      type: Boolean,
    },
  },

  computed: {
    productIsEditable() {
      return !this.readOnly && this.pageType?.toLowerCase() === "hero";
    },

    featuredInfoType() {
      if (this.hasFeaturedInfo) {
        if (this.inStockGuarantee) {
          return "in_stock";
        } else {
          return "is_new";
        }
      } else {
        return null;
      }
    },

    hasFeaturedInfo() {
      return this.isNewStyle || this.inStockGuarantee;
    },

    isNewStyle() {
      return this.product?.is_new;
    },

    inStockGuarantee() {
      return this.product?.in_stock;
    },

    designDimensionASD() {
      return this.product?.precolored_dimension != null
        ? this.product?.precolored_dimension
        : this.precoloredDimension;
    },
    componentName() {
      return "product";
      // switch (this.product?.type) {
      //   case "product": {
      //     return this.product?.design ||
      //       this.product?.variants ||
      //       this.product?.design ||
      //       this.product?.style
      //       ? "Product"
      //       : "ProductInfo";
      //   }
      //   case "hero": {
      //     return "HeroDisplay";
      //   }
      //   default: {
      //     return "HTMLDisplay";
      //   }
    },

    playbookPageLayoutSize() {
      return this.itemsCount;
    },

    withImage() {
      return (
        this.pageType?.toLowerCase() === "products" ||
        this.pageType?.toLowerCase() === "designs"
      );
    },

    withDescription() {
      return (
        this.pageType?.toLowerCase() === "products" ||
        this.pageType?.toLowerCase() === "hero" ||
        this.pageType?.toLowerCase() === "outfit"
      );
    },

    withProductGrid() {
      return this.pageType?.toLowerCase() === "outfit" || this.withDescription;
    },

    /* rules for CSS, display items centered or with special alignment depending on # of items */
    hasMoreThanTwoItems() {
      return this.itemsCount > 2;
    },

    isLastItem() {
      return (
        this.itemIndex * 1 + 1 === this.itemsCount && this.hasMoreThanTwoItems
      );
    },
    /* end css rules */
  },

  components: {
    Product,
    HTMLDisplay,
    ProductInfo,
    HeroDisplay,
  },
};
</script>

<style lang="scss">
.playbook-page-column-item {
  display: flex;
  flex-direction: column;
  //justify-content: center;
  justify-content: flex-start;
  // max-height: 50%;
  //min-height: 25%;
  &.full-content {
    &.item-index-0 {
      justify-content: start;
    }
    &.last-item {
      justify-content: end;
    }
  }
}
.page-products,
.page-extras,
.page-designs,
.page-hero {
  .playbook-page-column {
    &.playbook-page-column-4 {
      width: 25% !important;
    }
    .playbook-page-column-item {
      height: 100%;
      &.playbook-page-column-item-1 {
        height: 100%;
      }
      &.playbook-page-column-item-2 {
        max-height: 50%;
      }
      &.playbook-page-column-item-3 {
        max-height: 33%;
      }
      &.playbook-page-column-item-4 {
        &.item-index-0 {
          // height: fit-content;
          min-height: auto;
        }
      }
    }
  }
}
.page-hero {
  .playbook-page-column {
    justify-content: center !important;
    padding: 0 !important;
    .playbook-page-column-item {
      height: 100%;
      max-height: 100% !important;
      &.playbook-page-column-item-2 {
        &.item-index-0 {
          max-height: 33% !important;
        }
        &.item-index-1 {
          .product {
            justify-content: flex-start !important;
          }
        }
      }
    }
  }
}
</style>
